module.exports = __webpack_public_path__ + "img/waiting.5333bd2c.gif";